import * as types from '../mutation-types'
import api from '@/api/agenda'
import moment from "moment";

// initial state
const state = {
    agenda: [],
    loaded: false,
}

const getters = {
    agenda: state => state.agenda,
    agendaLoaded: state => state.loaded,
    agendaTabs: (state) => {
        let tabs = {};
        state.agenda.forEach((event) => {
            let date = moment(event.startDate)
            let year = date.format('Y')
            let month = date.format('MMMM');
            if(!tabs[year]) {
                tabs[year] = {
                    id: year,
                    value: year,
                    months: {}
                }
            }
            if(!tabs[year][date.month()+1]) {
                tabs[year]['months'][date.month()+1] = {
                    id: `${year}-${date.month()+1}`,
                    name: month,
                    year: Number(year),
                    month: date.month()+1
                }
            }
        })
        return tabs;
    },
    agendaBoxes: (state) => (value) => {
        return state.agenda.filter((event) => {
            let date =  moment(event.startDate)
            let year = date.format('Y')
            let month = date.month()+1
            return Number(year) === value.year && value.month === month
        }).sort((a, b) => {
            a = moment(a.startDate)
            b = moment(b.startDate)
            return a.diff(b)
        })
    }
}

const actions = {
    getAgenda({ commit }) {
        commit(types.SET_AGENDA_LOADED, false );
        api.getAgenda({},(response) => {
            commit(types.SET_AGENDA, response._embedded.Agenda );
            commit(types.SET_AGENDA_LOADED, true );
        })
    },
    cleanAgenda({commit}) {
        commit(types.SET_AGENDA_LOADED, false );
        commit(types.SET_AGENDA, {} );
    }
}

const mutations = {
    [types.SET_AGENDA] (state, solution ) {
        state.agenda = solution
    },
    [types.SET_AGENDA_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


